import gql from 'graphql-tag';

export const CREATE = gql`
  mutation createReview($input: CreateReviewInput!) {
    createReview(input: $input)
  }
`;

export const USER_REVIEW = gql`
  mutation userCreateReview($input: UserCreateReviewInput!) {
    userCreateReview(input: $input)
  }
`;

export const UPDATE = gql`
  mutation updateReview($input: UpdateReviewInput!) {
    updateReview(input: $input)
  }
`;

export const DELETE = gql`
  mutation deleteReview($input: DeleteReviewInput!) {
    deleteReview(input: $input)
  }
`;
